import { useGameContainer } from '../index';
import styles from './styles/GameSeriesHeader.module.scss';

export default function GameSeriesHeader() {
  const [{ game }] = useGameContainer();

  const bracketSeries = game.contest.bracketSeries;
  if (!bracketSeries) return null;

  const bracketName = game.contest.bracket?.name;

  const currentContest = bracketSeries.bracketSeriesContests.find(
    seriesContest => seriesContest.primaryGame && seriesContest.primaryGame.id === game.id
  );

  if (!currentContest) {
    return null;
  }

  const currentGamePosition = currentContest.seriesPosition;

  return (
    <div className={styles.BracketInfo}>
      {bracketName} - Game {currentGamePosition}
    </div>
  );
}
